import Client from './Client';

export default class CourseClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取课程类型
   */
  async getPageCategory(data) {
    const res = await this.client.post('/api/course/pageCategory', data);
    return res;
  }

  /**
   * 禁用/启用/删除课程类型
   */
  async updateCategoryValid(data) {
    const res = await this.client.post('/api/course/updateCategoryValid', data);
    return res;
  }

  /**
   * 新增/修改 课程类型
   */
  async upsertCategory(data) {
    const res = await this.client.post('/api/course/upsertCategory', data);
    return res;
  }

  /**
   * 获取课程列表
   *
   *
   */
  async pageCourse(data) {
    const res = await this.client.post('/api/course/pageCourse', data);
    return res;
  }

  /**
   * 课程类型 - 下拉
   *
   */
  async listCategoryName() {
    const res = await this.client.post('/api/course/listCategoryName');
    return res;
  }

  /**
   * 课程详情
   *
   */
  async getCourseDetail(id) {
    const res = await this.client.get(`/api/course/getCourseDetail?courseClassId=${id}`);
    return res;
  }

  /**
   * 课程章节详情
   *
   */
  async listChapter(id) {
    const res = await this.client.get(`/api/course/listChapter?courseId=${id}`);
    return res;
  }

  /**
   * 修改章节
   *
   */
  async upsertChapter(data) {
    const res = await this.client.post('/api/course/upsertChapter', data);
    return res;
  }

  /**
   * 修改章节
   *
   */
  async deleteChapter(data) {
    const res = await this.client.post('/api/course/deleteChapter', data);
    return res;
  }

  /**
   * 修改章节
   *
   */
  async changeChapterRank(data) {
    const res = await this.client.post('/api/course/changeChapterRank', data);
    return res;
  }

  /**
   * 课程类型 - 下拉
   *
   */
  async listTeacher() {
    const res = await this.client.post('/api/user/listTeacher');
    return res;
  }

  /**
   * 课程类型 - 下拉
   *
   */
  async upsertCourseDetail(data) {
    const res = await this.client.post('/api/course/upsertCourseDetail', data);
    return res;
  }

  /**
   * 新增/修改 课程类型
   */
  async updateCourseValid(data) {
    const res = await this.client.post('/api/course/updateCourseValid', data);
    return res;
  }

  /**
   * 课程表模板详情
   */
  async getContentDetail(data) {
    const res = await this.client.post('/api/course/getContentDetail', data);
    return res;
  }

  /**
   * 课程表模板编辑
   */
  async desertScheduleContent(data) {
    const res = await this.client.post('/api/course/desertScheduleContent', data);
    return res;
  }

  /**
   * 课程表复制 新增/修改
   */
  async upsertSchedule(data) {
    const res = await this.client.post('/api/course/upsertSchedule', data);
    return res;
  }

  /**
   * 课程表详情
   */
  async getDetailSchedule(data) {
    const res = await this.client.post('/api/course/getDetailSchedule', data);
    return res;
  }

  /**
   * 课程表详情
   */
  async listDetailSchedule(data) {
    const res = await this.client.post('/api/course/listDetailSchedule', data);
    return res;
  }

  /**
   * 删除课程表
   */
  async deleteSchedule(data) {
    const res = await this.client.post('/api/course/deleteSchedule', data);
    return res;
  }

  /**
   * 评论列表
   */
  async pageComment(data) {
    const res = await this.client.post('/api/course/comment/pageComment', data);
    return res;
  }

  /**
   * 隐藏评论
   */
  async hideComment(data) {
    const res = await this.client.post('/api/course/comment/hideComment', data);
    return res;
  }

  /**
   * 展示评论
   */
  async showComment(data) {
    const res = await this.client.post('/api/course/comment/showComment', data);
    return res;
  }

  /**
   * 获取课程分享信息
   *
   */
  async courseGetShare(data) {
    const res = await this.client.post('/api/course/getShare', data);
    return res;
  }

  /**
   * 获取课程分享信息
   *
   */
  async updateShareQrCodeUrl(data) {
    const res = await this.client.post('/api/course/updateShareQrCodeUrl', data);
    return res;
  }

  /**
   * 测试生成分享图片
   *
   */
  async courseShareTest(data) {
    const res = await this.client.post('/api/course/shareTest', data);
    return res;
  }
}